module.exports = __webpack_public_path__ + "img/widow.151ae30a.png";